<template>
  <div class="listings">
    <h2 id="pickup"> Ready For Pickup: </h2>
    <item-table
      :items="bought"
      :headers="boughtHeaders"
      :coin="coin"
      :loading="loading"
      no-data="No items for pickup."
    >
    </item-table>
    <h2> Outstanding Buys: </h2>
    <item-table
      :items="buys"
      :headers="buyHeaders"
      :loading="loading"
      no-data="No outstanding buys."
    ></item-table>
    <h2> Outstanding Sells: </h2>
    <item-table
      :items="sells"
      :headers="sellHeaders"
      :loading="loading"
      no-data="No outstanding sells."
    ></item-table>
  </div>
</template>

<script>
/* eslint-disable arrow-body-style */
/* eslint-disable camelcase */
/* eslint-disable newline-per-chained-call */
import { mapMutations } from 'vuex';
import gw2client from 'gw2api-client';
import itemTable from '../components/ItemTable.vue';


function formatCoin(price) {
  const [c2, c1, s2, s1, ...gold] = price.toString().split('').reverse().map(x => parseInt(x, 10));
  const hasGold = gold.some(x => x);
  const hasCopper = [c1, c2].some(x => x);
  const formatItem = (items, label, force = false, suffix = '') => {
    if (!force && !items.some(x => x)) return '';
    return `${items.join('')}${label}${suffix}`;
  };
  const formatted = `${formatItem(gold.reverse(), 'g')}
      ${formatItem([s1, s2], 's', hasGold && hasCopper)}
      ${formatItem([c1, c2], 'c', false, '')}`;
  return formatted;
}

const getItemDetails = async (client) => {
  const formatPrice = ({ price, ...record }) => {
    const formatted = formatCoin(price);
    return {
      ...record,
      price: formatted,
    };
  };

  const [
    { coins, items: boughtItemsRaw },
    sellsRaw,
    buysRaw,
  ] = await Promise.all([
    client.commerce().delivery().get(),
    client.commerce().transactions().current().sells().all().then(
      result => result.map(formatPrice),
    ),
    client.commerce().transactions().current().buys().all().then(result => result.map(formatPrice)),
  ]);

  const boughtItemsFormatted = boughtItemsRaw.map(
    ({ id: item_id, ...rest }) => ({ item_id, ...rest }),
  );

  const itemDetails = await client.items().many([
    ...boughtItemsFormatted,
    ...sellsRaw,
    ...buysRaw,
  ].map(
    ({ item_id }) => item_id,
  )).then((result) => {
    return result.reduce((acc, { id, ...item }) => {
      return {
        ...acc,
        [id]: item,
      };
    }, {});
  });

  return [
    ...[boughtItemsFormatted, sellsRaw, buysRaw].map(
      items => items.map(({ item_id: id, ...properties }) => ({
        ...itemDetails[id],
        ...properties,
        id,
      })),
    ),
    coins,
  ];
};

export default {
  data() {
    return {
      bought: [],
      boughtSearch: '',
      boughtHeaders: [
        {
          text: '', value: 'image', align: 'start', sortable: false, filterable: false,
        },
        { text: 'name', value: 'name', align: 'start' },
        { text: 'quantity', value: 'count' },
      ],
      sells: [],
      sellSearch: '',
      sellHeaders: [
        {
          text: '', value: 'image', align: 'start', sortable: false, filterable: false,
        },
        { text: 'name', value: 'name' },
        { text: 'price', value: 'price' },
        { text: 'quantity', value: 'quantity' },
      ],
      buys: [],
      buySearch: '',
      buyHeaders: [
        {
          text: '', value: 'image', align: 'start', sortable: false, filterable: false,
        },
        { text: 'name', value: 'name' },
        { text: 'price', value: 'price' },
        { text: 'quantity', value: 'quantity' },
      ],
      coin: null,
      loading: true,
    };
  },
  components: {
    itemTable,
  },
  methods: {
    ...mapMutations(['setApiKey']),
  },
  mounted() {
    const { key } = this.$route.query;
    if (!key || key.length !== 72) {
      this.$router.push('/settings');
      return;
    }
    this.setApiKey(key);
    const client = gw2client();
    client.schema('2019-03-26T00:00:00Z');
    client.language('en');
    client.authenticate(key);
    getItemDetails(client).then(([bought, sells, buys, coin]) => {
      this.loading = false;
      this.buys = buys;
      this.bought = bought;
      this.sells = sells;
      this.coin = formatCoin(coin);
    });
  },
};
</script>
<style>

.listings {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex-direction: column;
}

h2 {
  margin-top: 3rem;
  margin-bottom: 0.5rem;
  font-size: 1.8rem;
}

#pickup {
  margin-top: 0rem;
}

.label {
  font-size: 1.2rem;
  width: 100%;
  margin-bottom: 0.3rem;
}

#changeKey {
  margin-top: 3rem;
}

.text-start {
  text-align: left;
}
</style>
